// Colour by status (ok/off), not by trend direction.
// A falling-but-in-range value stays cyan.
export function Sparkline({ data, status, w = 72, h = 22 }) {
  if (!data || data.length < 2) {
    return (
      <div style={{ width: w, height: h, display: 'flex', alignItems: 'center' }}>
        <div className="font-mono" style={{ fontSize: 12, color: 'var(--text-dim)' }}>
          —
        </div>
      </div>
    );
  }
  const pad = 2;
  const values = data.map((d) => (typeof d === 'number' ? d : d.value));
  const min = Math.min(...values),
    max = Math.max(...values);
  const range = max - min || 1;
  const pts = values
    .map((v, i) => {
      const x = pad + (i * (w - pad * 2)) / (values.length - 1);
      const y = h - pad - ((v - min) / range) * (h - pad * 2);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  const stroke = status === 'off' ? 'var(--alert)' : 'var(--cyan)';
  // The old SVG had overflow:visible and no viewBox, so on a narrow
  // 2-col param card (where the big value squeezes this row) the
  // 72px-wide polyline drew past the shrunk box and spilled into the
  // neighbouring card. Fix: a viewBox + preserveAspectRatio:none lets
  // the line scale to whatever width the flex row leaves, minWidth:0 +
  // flexShrink:1 lets it yield space to the value first, and overflow
  // is clipped. non-scaling-stroke keeps the 1.5px line crisp when the
  // box is compressed.
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      style={{ display: 'block', flexShrink: 1, minWidth: 0, maxWidth: w, overflow: 'hidden' }}
    >
      <polyline
        points={pts}
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
